import { PieArcDatum } from 'd3';
import { Center, Spinner } from 'src/components/atoms';
import { BarHorizontal, Donut } from 'src/components/molecules';
import {
  BarChartContainer,
  DonutAndBarHorizontalContainer,
  DonutContainer,
} from '../../EthicalHealthDataview/EthicalHealthDataview.styles';
import { LoadingContainer } from './DonutAndBarContent.styles';

interface BarDataItem {
  bar: number;
  label: string;
  value: number;
  percentage?: number;
}

interface Props {
  isLoading: boolean;
  donutData: { [index: string]: number } | undefined;
  onDonutClick: (d: PieArcDatum<[string, number]>) => void;
  centerLabel: string;
  selectedSegment?: string;
  barData: BarDataItem[] | undefined;
  barXTitle: string;
  barYTitle: string;
  barColor: string;
  xAxisMax: number | undefined;
  pdfIsDownloading: boolean;
  categoryAxisLabelCount: number;
}

export const DonutAndBarContent = ({
  isLoading,
  donutData,
  onDonutClick,
  centerLabel,
  selectedSegment,
  barData,
  barXTitle,
  barYTitle,
  barColor,
  xAxisMax,
  pdfIsDownloading,
  categoryAxisLabelCount,
}: Props) => {
  if (isLoading) {
    return (
      <div data-testid="donut-and-bar-content-loading">
        <Center as={LoadingContainer}>
          <Spinner data-testid="spinner" variant="secondary" size="xlarge" />
        </Center>
      </div>
    );
  }

  return (
    <DonutAndBarHorizontalContainer data-testid="donut-and-bar-content">
      <DonutContainer data-testid="donut-and-bar-content-donut">
        <Donut
          data={donutData}
          onClick={onDonutClick}
          centerLabel={centerLabel}
          selectedSegment={selectedSegment}
        />
      </DonutContainer>
      {barData && (
        <BarChartContainer data-testid="donut-and-bar-content-bar">
          <BarHorizontal
            xTitle={barXTitle}
            yTitle={barYTitle}
            data={barData}
            monocolor={barColor}
            xAxisMax={xAxisMax}
            graphId="issue-by-intake-horizontal-bar"
            tooltip={true}
            tooltipType={'donut-and-bar-horizontal'}
            pdfIsDownloading={pdfIsDownloading}
            pdfDownloadHeight={Math.max(categoryAxisLabelCount * 40, 450)}
          />
        </BarChartContainer>
      )}
    </DonutAndBarHorizontalContainer>
  );
};
